import { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@shared/ui/card";
import { Button } from "@shared/ui/button";
import { Plus } from "lucide-react";
import { DisconnectionReasonsTable } from "./disconnectionLanding/disconnectionLanding";
import { DisconnectionReasonDialog } from "./disconnectionAdd/disconnectionAdd";

export function DisconnectionSettings() {
  const [showDialog, setShowDialog] = useState(false);
  const [editingReason, setEditingReason] = useState(null);

  const handleAddReason = () => {
    setEditingReason(null);
    setShowDialog(true);
  };

  const handleEditReason = (reason: any) => {
    setEditingReason(reason);
    setShowDialog(true);
  };

  const handleCloseDialog = () => {
    setShowDialog(false);
    setEditingReason(null);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <p className="card-heading-text">Disconnection Reasons Configuration</p>
            <p className="page-subtitle">
              Configure disconnection reasons with their timing requirements and
              priorities
            </p>
        </div>
        <Button onClick={handleAddReason}>
          <Plus className="mr-2 h-4 w-4" />
          Add Reason
        </Button>
      </div>
      <DisconnectionReasonsTable onEditReason={handleEditReason} />

      <DisconnectionReasonDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        reason={editingReason}
        onClose={handleCloseDialog}
      />
    </div>
  );
}
